// 官方網址
const OFFICIAL_URL = {
    FACEBOOK: 'https://www.facebook.com/SouNova.tw',
    INSTAGRAM: 'https://www.instagram.com/sounova.tw/',
    THREADS: 'https://www.threads.net/@sounova.tw',
    CDN_BASE: 'https://cdn.sounova.com',
    META_FACEBOOK: 'https://cdn.sounova.com/assets/default/images/facebook_share.jpg',
    META_TWITTER: 'https://cdn.sounova.com/assets/default/images/twitter_share.jpg',
};

// 語系文檔用
const I18N_NAMESPACES = {
    INDEX: ['index'],
    HEADER: ['header'],
    FOOTER: ['footer'],
    MODAL: ['modal'],
    CATEGORY: ['category'],
    SEARCH: ['search'],
    AUTHOR: ['author'],
    NEWS: ['news'],
};

// 選單頁面連結
const NAV_MENU = {
    PORN: 'PORN',
    NORMAL: 'NORMAL',
    FORUM: 'FORUM',
    SHOP: 'SHOP',
};

// footer 連結
const FOOTER_PAGE = [
    {
        title: '關於我們',
        titleCn: '关于我们',
        link: '/about',
        gtm: 'about',
    },
    {
        title: '站規',
        titleCn: '站规',
        link: '/rules',
        gtm: 'rules',
    },
    {
        title: '服務條款',
        titleCn: '服务条款',
        link: '/terms-of-service',
        gtm: 'terms-of-service',
    },
    {
        title: '隱私權政策',
        titleCn: '隐私权政策',
        link: '/privacy-policy',
        gtm: 'privacy-policy',
    },
    {
        title: '工商合作',
        titleCn: '工商合作',
        link: 'mailto:business@sounova.com',
        gtm: 'business',
    },
    {
        title: '新聞稿投遞',
        titleCn: '新闻稿投递',
        link: 'mailto:news@sounova.com',
        gtm: 'contact',
    },
];

// 分類列表
const CATEGORY_LIST = ['allnews', 'game', 'anime', 'novel', 'term', 'news'];
const CATEGORY_LIST_MAP = {
    game: {
        title: '澀澀遊戲｜SouNova 少女星',
        titleCn: '涩涩游戏｜SouNova 少女星',
    },
    novel: {
        title: '澀澀小說｜SouNova 少女星',
        titleCn: '涩涩小说｜SouNova 少女星',
    },
    anime: {
        title: '澀澀動漫｜SouNova 少女星',
        titleCn: '涩涩动漫｜SouNova 少女星',
    },
    term: {
        title: '澀澀星知｜SouNova 少女星',
        titleCn: '涩涩星知｜SouNova 少女星',
    },
    news: {
        title: '澀澀話題｜SouNova 少女星',
        titleCn: '涩涩话题｜SouNova 少女星',
    },
};

// 中分類  全部、乙女向、耽美向、一般向、其他
const CLASSIFICATION_LIST = [
    'ALL',
    'OTOME',
    'BL',
    'BG',
    'COMPOSITE',
    'NOUNS',
    'TREND',
    'STAR',
    'EVENT',
    'POPULAR',
    'OTHERS',
];

// 搜尋分類 全部、遊戲、動漫、小說、星知、話題
const SEARCH_TYPE = ['ALL', 'GAME', 'ANIME', 'NOVEL', 'TERM', 'NEWS'];

// footer 社群連結
const FOOTER_SOCIAL = {
    facebook: {
        link: OFFICIAL_URL.FACEBOOK,
    },
    instagram: {
        link: OFFICIAL_URL.INSTAGRAM,
    },
    threads: {
        link: OFFICIAL_URL.THREADS,
    },
};

// 手機版置底選單
const MOBILE_MENU = ['PORN', 'NEWS', 'FORUM', 'SHOP', 'MINE'];

// 社群分享
const SHARE_LINK = [
    { title: 'threads', link: 'https://www.threads.net/intent/post?url=', width: 24, height: 25 },
    {
        title: 'line',
        link: 'https://social-plugins.line.me/lineit/share?url=',
        width: 24,
        height: 24,
    },
    {
        title: 'plurk',
        link: 'https://www.plurk.com/?qualifier=shares&status=',
        width: 26,
        height: 26,
    },
    {
        title: 'facebook',
        link: 'https://www.facebook.com/sharer/sharer.php?u=',
        width: 23,
        height: 24,
    },
    { title: 'twitter', link: 'http://twitter.com/share?url=', width: 18, height: 18 },
    { title: 'copy', width: 17, height: 17 },
];

// 預設圖檔
const DEFAULT_IMG = OFFICIAL_URL.META_FACEBOOK;
const DEFAULT_USER_IMG = '/images/layout/default_head.png';
const DEFAULT_LIST_BG = '/images/layout/default_list_bg.webp';

// 首頁 api
const HOME_API_ROUTER_PATH = {
    getHome: '/api/v1/home', // 取得首頁
    findBanner: '/api/v1/ad/banners', // 取得banner
};

const NEWS_API_ROUTER_PATH = {
    findList: '/api/v1/news', // 取得新聞list
};

// 報導者 api
const REPORTER_API_ROUTER_PATH = {
    findReporterNewsByCode: '/api/v1/news/reporter/',
    getReporterInfo: '/api/v1/news/reporter/info/',
};

// 全站廣告欄位
const PROMO_BANNER_POSITION_CODE = {
    MENU_BANNER: 'H18_MENU_BANNER',
    SIDE_BANNER: 'H18_SIDE_BANNER',
    LIST_BACKGROUND: 'H18_LIST_BACKGROUND',
    BOTTOM_BANNER_PC: 'H18_BOTTOM_BANNER_PC',
    BOTTOM_BANNER_MB: 'H18_BOTTOM_BANNER_MB',
    MAIN_MENU_BANNER: 'Main_Menu_banner',
    H18_BOTTOM_RIGHT_POPUP_MB: 'H18_BOTTOM_RIGHT_POPUP_MB', // 首頁手機版廣告彈窗
};

const META_DESCRIPTION = {
    INDEX: {
        tw: 'SouNova少女星澀澀專區(H-GIRL)，專為女性向18+內容打造的情報站！聚焦於遊戲、動漫及小說領域成人向內容，涵蓋新作發表、改版更新、限時活動、聯動合作等多元資訊，並且即時分享除遊戲、動漫、小說之外的線下活動、周邊商品、跨領域精彩資訊。開啟一場臉紅心跳的探索之旅，發現專屬自己的悸動瞬間！',
        cn: 'SouNova少女星涩涩专区(H-GIRL)，专为女性向18+内容打造的情报站！聚焦于游戏、动漫及小说领域成人向内容，涵盖新作发表、改版更新、限时活动、联动合作等多元资讯，并且即时分享除游戏、动漫、小说之外的线下活动、周边商品、跨领域精彩资讯。开启一场脸红心跳的探索之旅，发现专属自己的悸动瞬间！',
    },
    GAME: {
        tw: '澀澀遊戲新聞提供女性向遊戲的最新動態，涵蓋新作發表、改版更新、限時活動、聯動合作等多元資訊，確保不錯過任何精彩消息！不論是戀愛冒險、乙女向R18、成人向RPG、BL題材禁區，這裡都能找到最即時的情報。同時，我們也分享玩家心得、官方發表、業界趨勢，確保不錯過任何令人心跳加速的遊戲內容。',
        cn: '涩涩游戏新闻提供女性向游戏的最新动态，涵盖新作发表、改版更新、限时活动、联动合作等多元资讯，确保不错过任何精彩消息！不论是恋爱冒险、乙女向R18、成人向RPG、BL题材禁区，这里都能找到最即时的情报。同时，我们也分享玩家心得、官方发表、业界趋势，确保不错过任何令人心跳加速的游戏内容。',
    },
    NOVEL: {
        tw: '澀澀小說新聞匯集女性向18+小說圈的最新資訊，帶來新書發售、話題作品、改編動態、限量特典等豐富內容。不論是深情纏綿的乙女物語、激情四溢的BL世界，還是挑戰禁忌的暗黑題材，這裡都有最全面的情報。時刻關注讀者熱議趨勢、作家動向、限定周邊，帶你深入挖掘每一本讓人悸動不已的作品，沉浸在無法抗拒的故事魅力！',
        cn: '涩涩小说新闻汇集女性向18+小说圈的最新资讯，带来新书发售、话题作品、改编动态、限量特典等丰富内容。不论是深情缠绵的乙女物语、激情四溢的BL世界，还是挑战禁忌的暗黑题材，这里都有最全面的情报。时刻关注读者热议趋势、作家动向、限定周边，带你深入挖掘每一本让人悸动不已的作品，沉浸在无法抗拒的故事魅力！',
    },
    ANIME: {
        tw: '澀澀動漫新聞分享成人向動畫、漫畫、有聲書、ASMR等資訊內容，包括新作上市、精彩預告、熱門推薦等多元內容。無論是乙女或耽美BL，從經典人氣到冷門獵奇，從甜美浪漫到禁忌邊界，這裡滿足你的每一種喜好！輕鬆掌握成人向動漫市場的最新趨勢，探索話題作品、粉絲熱議內容，發掘更多讓人心跳加速的精彩世界！',
        cn: '涩涩动漫新闻分享成人向动画、漫画、有声书、ASMR等资讯内容，包括新作上市、精彩预告、热门推荐等多元内容。无论是乙女或耽美BL，从经典人气到冷门猎奇，从甜美浪漫到禁忌边界，这里满足你的每一种喜好！轻松掌握成人向动漫市场的最新趋势，探索话题作品、粉丝热议内容，发掘更多让人心跳加速的精彩世界！',
    },
    TERM: {
        tw: '澀澀專區 - 星知，提供18+女性向內容的知識庫與深度報導，包括熱門名詞解析、市場趨勢分析、專題探討等專業資訊。無論是各種成人向用語、創作類型解析、業界發展趨勢，還是文化現象與歷史脈絡，這裡都能帶你深入了解，讓每一位讀者都能更輕鬆地探索這個世界。',
        cn: '涩涩专区 - 星知，提供18+女性向内容的知识库与深度报导，包括热门名词解析、市场趋势分析、专题探讨等专业资讯。无论是各种成人向用语、创作类型解析、业界发展趋势，还是文化现象与历史脉络，这里都能带你深入了解，让每一位读者都能更轻松地探索这个世界。',
    },
    NEWS: {
        tw: '澀澀專區 - 話題，匯聚女性向18+領域的多元新聞資訊，涵蓋Vtuber 動態、舞台劇情報、線下活動、成人周邊等豐富內容。從熱門趨勢焦點到粉絲熱議話題，不僅分享最新消息，也發掘更多值得關注的女性向成人娛樂與文化焦點，拓展熱愛的邊界，滿足女性向愛好的私慾！',
        cn: '涩涩专区 - 话题，汇聚女性向18+领域的多元新闻资讯，涵盖Vtuber 动态、舞台剧情报、线下活动、成人周边等丰富内容。从热门趋势焦点到粉丝热议话题，不仅分享最新消息，也发掘更多值得关注的女性向成人娱乐与文化焦点，拓展热爱的边界，满足女性向爱好的私慾！',
    },
    SEARCH: {
        tw: '輸入想要查找的女性向作品關鍵字，認識更多精彩、不容錯過的作品新聞、最新資訊與深度解析。我們精選各類女性向作品，包括戀愛、奇幻、懸疑等多種題材，讓你輕鬆掌握話題趨勢。不論是新作情報、經典回顧，還是角色介紹、劇情解析，都能在這裡找到你感興趣的內容。立即搜尋，發現更多值得關注的女性向佳作！',
        cn: '输入想要查找的女性向作品关键字，认识更多精彩、不容错过的作品新闻、最新资讯与深度解析。我们精选各类女性向作品，包括恋爱、奇幻、悬疑等多种题材，让你轻松掌握话题趋势。不论是新作情报、经典回顾，还是角色介绍、剧情解析，都能在这里找到你感兴趣的内容。立即搜寻，发现更多值得关注的女性向佳作！',
    },
};

// google tag manager id
const GTM = {
    ID: 'GTM-PSKKFM4R',
    IFRAME_SOURCE: 'https://www.googletagmanager.com/ns.html?id=GTM-PSKKFM4R',
};

const IS_LIST_PATH = [
    '/',
    '/cn',
    '/game',
    '/cn/game',
    '/novel',
    '/cn/novel',
    '/anime',
    '/cn/anime',
    '/term',
    '/cn/term',
    '/news',
    '/cn/news',
];

// 檢舉理由
const REPORT_RULES = ['violent', 'porn', 'abuse', 'spam', 'fraud', 'other'];

module.exports = {
    OFFICIAL_URL,
    I18N_NAMESPACES,
    NAV_MENU,
    FOOTER_PAGE,
    CATEGORY_LIST,
    CATEGORY_LIST_MAP,
    CLASSIFICATION_LIST,
    SEARCH_TYPE,
    FOOTER_SOCIAL,
    MOBILE_MENU,
    SHARE_LINK,
    DEFAULT_IMG,
    DEFAULT_USER_IMG,
    DEFAULT_LIST_BG,
    HOME_API_ROUTER_PATH,
    NEWS_API_ROUTER_PATH,
    REPORTER_API_ROUTER_PATH,
    PROMO_BANNER_POSITION_CODE,
    META_DESCRIPTION,
    GTM,
    IS_LIST_PATH,
    REPORT_RULES,
};
